import palette from './palette';

const typography = {
	h1: {
		color: palette.text.primary,
		fontWeight: 700,
		fontSize: '50px',
		lineHeight: '57px',
		letterSpacing: '-1px',
		fontFamily: 'Gilroy',
		opacity: 1
	},
	h2: {
		color: palette.text.primary,
		fontSize: 32,
		fontFamily: 'Gilroy',
		fontWeight: 'bold',
		lineHeight: '50px'
	},
	h3: {
		color: palette.text.primary,
		fontWeight: 500,
		fontSize: '24px',
		letterSpacing: '-0.06px',
		lineHeight: '28px',
		fontFamily: 'Gilroy'
	},
	h4: {
		color: palette.text.primary,
		fontWeight: 500,
		fontSize: '20px',
		letterSpacing: '-0.06px',
		lineHeight: '24px',
		fontFamily: 'Gilroy'
	},
	h5: {
		color: palette.text.primary,
		fontWeight: 500,
		fontSize: '16px',
		letterSpacing: '-0.05px',
		lineHeight: '20px',
		fontFamily: 'Gilroy'
	},
	h6: {
		color: palette.text.primary,
		fontWeight: 500,
		fontSize: '14px',
		letterSpacing: '-0.05px',
		lineHeight: '20px',
		fontFamily: 'Gilroy'
	},
	subtitle1: {
		color: palette.text.primary,
		fontSize: '16px',
		letterSpacing: '-0.05px',
		lineHeight: '25px',
		fontFamily: 'Gilroy'
	},
	subtitle2: {
		color: palette.text.secondary,
		fontWeight: 400,
		fontSize: '14px',
		letterSpacing: '-0.05px',
		lineHeight: '21px',
		fontFamily: 'Gilroy'
	},
	body1: {
		color: palette.text.primary,
		fontSize: '14px',
		letterSpacing: '-0.05px',
		lineHeight: '21px',
		fontFamily: 'Roboto'
	},
	body2: {
		color: palette.text.secondary,
		fontSize: '12px',
		letterSpacing: '-0.04px',
		lineHeight: '18px',
		fontFamily: 'Roboto'
	},
	 /*button: {
        color: palette.text.primary,
        fontSize: "14px",
        fontFamily: "Ubuntu",
    }, */
	caption: {
		color: palette.text.secondary,
		fontSize: '11px',
		letterSpacing: '0.33px',
		lineHeight: '13px',
		fontFamily: 'Roboto'
	},
	overline: {
		color: palette.text.secondary,
		fontSize: '11px',
		fontWeight: 500,
		letterSpacing: '0.33px',
		lineHeight: '13px',
		textTransform: 'uppercase',
		fontFamily: 'Roboto'
	},
	paragraph: {
		color: palette.text.primary,
		fontSize: 14,
		fontFamily: 'Roboto',
		fontWeight: '600',
		lineHeight: '24px',
		opacity: 1
	},
	cardBody: {
		color: palette.text.primary,
		fontSize: 13,
		fontFamily: 'Roboto',
		lineHeight: '20px',
		letterSpacing: '-0.26px'
	},
	button: {
		color: '#FAFAF5',
		fontFamily: 'Bebas Neue',
		textTransform: 'uppercase',
		fontWeight: 700,
		paddingTop: 5,
		fontSize: '18px',
		// lineHeight: "18px",
		// letterSpacing: "0.18px",
		textAlign: 'left'
		// height: "24px",
	}
};

export default typography